import Contact2SaleMapper from "../Contact2SaleMapper";
import type { RuleItemEditorBaseProps } from "../ruleItemEditorTypes";

type Props = RuleItemEditorBaseProps & { data: any };

export default function RuleItemEditorContact2Sale({
  ruleItem,
  updateRuleItem,
  data: _data,
}: Props) {
  return (
    <Contact2SaleMapper
      ruleMappings={ruleItem.data.mappings}
      onChange={(mappings) => {
        updateRuleItem({
          ...ruleItem,
          data: {
            ...ruleItem.data,
            mappings,
          },
        });
      }}
    />
  );
}
